import { useState } from "react";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { Edit2Icon } from "lucide-react";
import Message from "../../../../i18n/Message";
import { updateGateway } from "../store/gatewayActionCreators";

import "./GatewayTitle.scss";

const GatewayTitle = ({ gateway, workspaceId }) => {
  const [editMode, setEditMode] = useState(false);
  const [name, setName] = useState(gateway.name);
  const [inProgress, setInProgress] = useState(false);
  const dispatch = useDispatch();
  const intl = useIntl();

  const onSave = (e) => {
    e.preventDefault();
    if (!name.trim()) return;

    setInProgress(true);
    dispatch(
      updateGateway(
        intl,
        workspaceId,
        gateway.uid,
        { name: name.trim() },
        () => {
          setInProgress(false);
          setEditMode(false);
        },
        () => {
          setInProgress(false);
        }
      )
    );
  };

  const onCancel = () => {
    setName(gateway.name);
    setEditMode(false);
  };

  return (
    <form onSubmit={onSave}>
      <div className="gateway_name">
        {!editMode && (
          <>
            {gateway.name}
            <div className="edit" onClick={() => setEditMode(true)}>
              <Edit2Icon size={16} color="#cb0c9f" />
            </div>
          </>
        )}
        {editMode && (
          <>
            <input
              type="text"
              className="form-control"
              value={name}
              onChange={(e) => setName(e.target.value)}
              disabled={inProgress}
              autoFocus
            />
            <button
              type="submit"
              className="btn btn-sm bg-gradient-dark"
              disabled={inProgress}
            >
              <Message id="save" />
            </button>
            <button
              type="button"
              className="btn btn-sm btn-outline-secondary"
              onClick={onCancel}
              disabled={inProgress}
            >
              <Message id="cancel" />
            </button>
          </>
        )}
      </div>
    </form>
  );
};

export default GatewayTitle;
